<template>
    <DsButton
        v-if="editAvailableClientSheet?.editAvailable"
        leading="fa-regular fa-pen"
        size="sm"
        variant="tertiary"
        @click.stop="editAvailableClientSheet?.openEditClientSheet(String(clientId))"
    >
        Edit client
    </DsButton>
</template>

<script setup lang="ts">
import DsButton from '@/components/design-system/form/input/DsButton.vue';
import type { Client } from '@/components/Views/Company/File/file.types';
import { EDIT_AVAILABLE_CLIENT_SHEET_INJECTION_KEY } from '@/injection-keys';
import { inject } from 'vue';

defineProps<{
    clientId: Client['id'];
}>();

const editAvailableClientSheet = inject(EDIT_AVAILABLE_CLIENT_SHEET_INJECTION_KEY, {
    editAvailable: false, // explicitly disable edit on pages that don't inject editor
    openEditClientSheet() {},
});
</script>
